<template>
  <main class="home">
    <div v-if="!loading">
      <transactList :transacts="transacts" @show="onShow"/>
      <modal v-model="modal" @close="onModal">
        <h5 slot="header">Détails transaction<sub><a href="#">#{{transact.id}}</a></sub></h5>
        <table class="table table-hover">
          <tr><th><i class="fa fa-key"></i> Id</th><td>{{transact.id}}</td></tr>
          <tr><th><i class="fa fa-calendar-alt"></i> Date</th><td>{{transact.activedAt || transact.updatedAt}}</td></tr>
          <tr><th><i class="fa fa-random"></i> Number</th><td>{{transact.number || transact.mini}}</td></tr>
          <tr><th><i class="fa fa-binoculars"></i> Montant</th><td>{{transact.amount}} lR</td></tr>
          <tr v-if="transact.rate"><th><i class="fa fa-percent"></i> Taux</th><td>{{transact.rate.id}}</td></tr>
          <tr v-if="transact.to"><th><i class="fa fa-user"></i> Provient de</th><td>{{transact.to.name}}</td></tr>
          <tr v-if="transact.admins"><th><i class="fa fa-users"></i> Admins</th><td><span class="badge badge-primary badge-pill" v-for="(item, index) in transact.admins" :key="index">{{item.name}}</span></td></tr>
          <tr><th><i class="fa fa-wrench"></i> Type</th><td>{{transact.type}}</td></tr>
          <tr v-if="$store.getters.loggedAs.type === 'Officiel' && transact.type !== 'Souscri' && transact.type !== 'Transfer'"><th><i class="fa fa-cogs"></i> Actions</th><td>
            <button class="btn btn-block btn-primary mr-2" v-if="!(transact.activedAt || transact.author)" @click="$store.dispatch('transact/updateTrans', transact)"><i class="fa fa-check"></i></button>
            <button :class="['btn', transact.status === 'inPROGRESS' ? 'btn-outline-warning': 'btn-outline-danger']" v-if="!(transact.type !== 'Bond' && transact.status !== 'COMPLETED')" @click="$store.dispatch('transact/setatusTrans', transact)"><i class="fa fa-check"></i></button>
          </td></tr>
        </table>
      </modal>
    </div>
    <loader v-else/>
  </main>
</template>

<script>
let transactList = {
  props: {
    transacts: Object
  },
  template: `
  <table class="table table-striped">
    <thead class="thead-dark">
      <tr>
        <th scope="col"><i class="fa fa-clock"></i> Date</th>
        <th scope="col"><i class="fa fa-money-bill"></i> Montant</th>
        <th scope="col"><i class="fa fa-tag"></i> Type</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="transact in transacts" :key="transact.id" @click.prevent="$emit('show', transact)">
        <th scope="row">{{ transact.updatedAt }}</th>
        <td>{{transact.amount}}</td>
        <td>{{transact.type}} <span :class="['badge badge-pill', (transact.activedAt || transact.author) ? 'badge-success' : 'badge-danger']"><i class="fa fa-check"></i></span></td>
      </tr>
    </tbody>
  </table>
  `
};

export default {
  name: 'transact',
  data() {
    return { modal: 'transact', loading: true, transact: {}, timer: undefined}
  },
  computed: {
    transacts() { return this.$store.getters['transact/all']; },
    numberTotal: {
      get() {
          return this.numbers.reduce((sum, val) => sum + val);
      },
      set(newValue) {
          const oldValue = this.numberTotal;
          const difference = newValue - oldValue;
          this.numbers.push(difference);
      }
    },
  },
  methods: {
    onShow(value){
      this.transact = { ...value };
      this.onModal(this.modal)
    },
    onModal() {$(`#${this.modal}`).modal('toggle')}
  },
  created() { 
    this.$store.dispatch('transact/fetchTrans')
      .then(() => this.loading = false)
      .finally(() => this.timer = setInterval(() => this.$store.dispatch('transact/fetchTrans'), 15000)); //setTimeout();
  },
  destroyed() {
      if(this.timer)
          clearInterval(this.timer); //clearTimeout()
  },
  components: {transactList}
}
</script>

<style scoped lang="scss"></style>
